module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [(_vm.showModal) ? _c('download-modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3 panel settings-panel",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "15px",
      "padding-right": "15px"
    }
  }, [_c('div', {
    staticClass: "configuration-panel"
  }, [_c('h2', [_vm._v("General Information")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2",
    staticStyle: {
      "box-sizing": "border-box",
      "padding-right": "2px"
    }
  }, [_c('configurator-input', {
    attrs: {
      "placeholder": 'Project Title',
      "storeProperty": 'projectTitle',
      "storeCommitEvent": 'UPDATE_PROJECT_TITLE'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2",
    staticStyle: {
      "box-sizing": "border-box",
      "padding-left": "2px"
    }
  }, [_c('configurator-input', {
    attrs: {
      "placeholder": 'Username',
      "storeProperty": 'username',
      "storeCommitEvent": 'UPDATE_USERNAME'
    }
  })], 1)]), _vm._v(" "), _c('configurator-shield'), _vm._v(" "), _c('configurator-showcase'), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "title": 'Description',
      "placeholder": 'Describe your project',
      "rows": 2,
      "storeProperty": 'projectDescription',
      "storeCommitEvent": 'UPDATE_PROJECT_DESCRIPTION'
    }
  }), _vm._v(" "), _c('configurator-list-add'), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "title": 'Installation',
      "placeholder": 'Provide Installation instructions',
      "rows": 2,
      "storeProperty": 'projectInstallation',
      "storeCommitEvent": 'UPDATE_INSTALLATION'
    }
  }), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "title": 'How To Use',
      "placeholder": 'Describe on how to use the project',
      "rows": 2,
      "storeProperty": 'projectHowToUse',
      "storeCommitEvent": 'UPDATE_HOW_TO_USE'
    }
  }), _vm._v(" "), _c('configurator-examples'), _vm._v(" "), _c('div', [_c('configurator-textarea', {
    attrs: {
      "title": 'Contributing',
      "placeholder": 'Describe how people can contribute',
      "rows": 2,
      "storeProperty": 'contributing',
      "storeCommitEvent": 'UPDATE_CONTRIBUTING'
    }
  })], 1), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Resources")]), _vm._v(" "), _c('h3', [_vm._v("Motivation")]), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "placeholder": 'Describe what you motivated to start the project',
      "rows": 2,
      "storeProperty": 'motivation',
      "storeCommitEvent": 'UPDATE_MOTIVATION'
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Architecture")]), _vm._v(" "), _c('configurator-textarea', {
    attrs: {
      "placeholder": 'Give a summary of the architecture of your project',
      "rows": 2,
      "storeProperty": 'architecture',
      "storeCommitEvent": 'UPDATE_ARCHITECTURE'
    }
  }), _vm._v(" "), _c('configurator-documentation')], 1), _vm._v(" "), _c('configurator-contact'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('h2', [_vm._v("License")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.license),
      expression: "license"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.license = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("MIT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("BSD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("GPL")])])]), _vm._v(" "), _c('div', [_c('vue-r-button', {
    attrs: {
      "label": 'Load Contributors',
      "onClick": _vm.loadContributors
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('configurator-checkbox', {
    attrs: {
      "text": 'Link to this Project',
      "storeProperty": 'showVueReadme',
      "storeCommitEvent": 'UPDATE_SHOW_VUE_README'
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-2 panel readme-panel"
  }, [_c('readme-preview')], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-6 panel menu-panel",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "20px",
      "padding-right": "20px"
    }
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Create README.md',
      "onClick": _vm.showModalFct
    }
  })], 1), _vm._v(" "), _c('div')])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50e9da47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 66
// module chunks = 0